var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BnTableBanner',{attrs:{"white":_vm.white,"title":_vm.content?.title,"description":_vm.content?.description,"ok-label":_vm.content?.buttonLabel},on:{"ok":function($event){return _vm.onOk()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }